export const hardCodeRecordFileId = 'recordFileId';
